import { MerchantFeaturesFlagsDto } from '@goparrot/store-v2-sdk';

export const showTargetType = (featuresFlags?: MerchantFeaturesFlagsDto): boolean =>
  Boolean(featuresFlags?.showLoyaltyManagement && featuresFlags?.showLoyaltyTarget);
